"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Donut = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _colors = _interopRequireDefault(require("../../../theme/colors"));

var _styled = require("./styled");

var Donut = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Donut, _PureComponent);

  var _super = (0, _createSuper2["default"])(Donut);

  function Donut() {
    (0, _classCallCheck2["default"])(this, Donut);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Donut, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          children = _this$props.children,
          size = _this$props.size,
          strokeWidth = _this$props.strokeWidth,
          backgroundCircleColor = _this$props.backgroundCircleColor,
          progressCircleColor = _this$props.progressCircleColor;
      var halfSize = size / 2;
      var radius = halfSize - 10;
      var circumference = 2 * Math.PI * radius;
      var offset = (100 - Math.min(value, 100)) / 100;
      return /*#__PURE__*/_react["default"].createElement(_styled.Wrapper, {
        height: size,
        width: size
      }, /*#__PURE__*/_react["default"].createElement(_styled.Svg, {
        height: size,
        width: size,
        viewport: "0 0 ".concat(halfSize, " ").concat(halfSize)
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfSize,
        cy: halfSize,
        fill: "transparent",
        stroke: backgroundCircleColor,
        strokeWidth: "".concat(strokeWidth, "px")
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfSize,
        cy: halfSize,
        fill: "transparent",
        strokeDasharray: circumference,
        strokeDashoffset: offset * circumference,
        strokeWidth: "".concat(strokeWidth, "px"),
        stroke: progressCircleColor,
        strokeLinecap: "round"
      })), /*#__PURE__*/_react["default"].createElement(_styled.Content, null, children));
    }
  }]);
  return Donut;
}(_react.PureComponent);

exports.Donut = Donut;
Donut.defaultProps = {
  children: null,
  size: 150,
  strokeWidth: 14,
  backgroundCircleColor: _colors["default"].orange[100],
  progressCircleColor: _colors["default"].blackberry[700]
};
var _default = Donut;
exports["default"] = _default;